const SPOTLIGHT_CATEGORIES = ['from-page-to-screen', 'having-a-moment', 'second-chapter'];
const text = value => (typeof value === 'string' ? value.trim() : '');
const normalizeIsbn = value =>
  text(value)
    .replace(/[-\s]/g, '')
    .toUpperCase();
const isValidIsbn = value => {
  const isbn = normalizeIsbn(value);
  if (/^97[89]\d{10}$/.test(isbn)) {
    return (
      [...isbn].reduce((sum, digit, index) => sum + Number(digit) * (index % 2 ? 3 : 1), 0) % 10 ===
      0
    );
  }
  if (/^\d{9}[\dX]$/.test(isbn)) {
    return (
      [...isbn].reduce(
        (sum, digit, index) => sum + (digit === 'X' ? 10 : Number(digit)) * (10 - index),
        0
      ) %
        11 ===
      0
    );
  }
  return false;
};
const coverUrlForIsbn = value => {
  const isbn = normalizeIsbn(value);
  return isValidIsbn(isbn)
    ? `https://covers.openlibrary.org/b/isbn/${encodeURIComponent(isbn)}-M.jpg?default=false`
    : null;
};

/** Normalize an editorial search pick, not a listing or a popularity/inventory claim. */
const normalizeSpotlightBook = book => {
  if (
    !book ||
    !text(book.title) ||
    !text(book.author) ||
    !SPOTLIGHT_CATEGORIES.includes(book.category)
  )
    return null;
  const isbn = normalizeIsbn(book.isbn);
  return {
    title: text(book.title),
    author: text(book.author),
    category: book.category,
    ...(text(book.editorialKey) ? { editorialKey: text(book.editorialKey) } : {}),
    ...(text(book.reasonLabel) ? { reasonLabel: text(book.reasonLabel) } : {}),
    ...(text(book.note) ? { note: text(book.note) } : {}),
    isbn: isValidIsbn(isbn) ? isbn : null,
    coverUrl: coverUrlForIsbn(isbn),
  };
};

/** Validate and deduplicate a configured list without propagating inventory or sales claims. */
const normalizeSpotlightBooks = (section, context = 'Discover Back in the Spotlight') => {
  if (!section) return [];
  if (!Array.isArray(section.books)) {
    console.error(`${context} requires a book list.`);
    return [];
  }
  const seen = new Set();
  return section.books.reduce((books, input) => {
    const book = normalizeSpotlightBook(input);
    if (!book) {
      console.error(`${context} has an invalid book or category.`);
      return books;
    }
    const key = `${book.title.toLowerCase()}|${book.author.toLowerCase()}`;
    if (seen.has(key)) return books;
    seen.add(key);
    return [...books, book];
  }, []);
};

module.exports = {
  SPOTLIGHT_CATEGORIES,
  isValidIsbn,
  normalizeSpotlightBook,
  normalizeSpotlightBooks,
  coverUrlForIsbn,
};
